import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import HomeTab from "./TextTab";
import EnvelopeTab from './EnvelopeTab';
import LinksTab from './LinksTab';
import DesignTab from './DesignTab';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      <Box p={3}>
        <Typography component="div">{children}</Typography>
      </Box>
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-prevent-tab-${index}`,
    'aria-controls': `scrollable-prevent-tabpanel-${index}`,
  };
}

export default function CustomizeTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <section id="CustomizeTabs" className="pc-section papercraft">
      <header className="pc-section__head">
        <span className="pc-eyebrow">Make it yours</span>
        <h2 className="pc-section__title">
          Fully <em style={{ fontStyle: "italic", color: "var(--pc-terracotta)" }}>customizable</em> design.
        </h2>
        <p className="pc-section__lede">
          Tune every detail — from the words on the page to the texture of the envelope,
          the links your guests follow, and even the artwork itself.
        </p>
      </header>

      <div className="pc-tabs">
        <AppBar position="static" color="primary" elevation={0}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            scrollButtons="off"
            aria-label="customization tabs"
          >
            <Tab label="Text"            {...a11yProps(0)} />
            <Tab label="Envelope"        {...a11yProps(1)} />
            <Tab label="Links"           {...a11yProps(2)} />
            <Tab label="Your Own Design" {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}><HomeTab /></TabPanel>
        <TabPanel value={value} index={1}><EnvelopeTab /></TabPanel>
        <TabPanel value={value} index={2}><LinksTab /></TabPanel>
        <TabPanel value={value} index={3}><DesignTab /></TabPanel>
      </div>
    </section>
  );
}
